// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"fbb81358","453":"80153738"}[chunkId] + ".chunk.js";
};